import React from 'react';
import { Tabs as MuiTabs, Tab, Stack, Typography } from '@mui/material';
import { PhxBadgeCounter } from '../PhxBadgeCounter/PhxBadgeCounter';
import { neutral, primary } from '_lex/_foundations/phxColors';

export interface TabItem {
  label: string | React.ReactNode;
  count?: number;
  value: string | number;
  disabled?: boolean;
}

export interface TabsProps {
  items: TabItem[];
  value: string | number;
  onChange: (event: React.SyntheticEvent, newValue: string | number) => void;
}

const Tabs: React.FC<TabsProps> = ({ items, value, onChange }) => {
  return (
    <MuiTabs
      className='lex-tabs'
      value={value}
      onChange={onChange}
    >
      {items.map((item) => (
        <Tab
          key={item.value}
          value={item.value}
          disabled={item.disabled}
          label={
            <Stack
              direction='row'
              spacing={2}
              margin={0}
              alignItems='center'
            >
              <Typography variant='subtitleMd'>{item.label}</Typography>
              {item.count !== undefined && (
                <PhxBadgeCounter
                  color={value === item.value ? 'primary' : 'default'}
                  number={item.count}
                  size='sm'
                />
              )}
            </Stack>
          }
          disableRipple
        />
      ))}
    </MuiTabs>
  );
};

export default Tabs;
